module.exports = __webpack_public_path__ + "img/login-logo.22eedf45.png";